import RouteBase from "./RouteBase";

export const HomeRoute = new RouteBase({
  key: "home",
  path: "/",
  priority: 0,
});

export const DashboardRoute = new RouteBase({
  key: "dashboard",
  priority: 1,
});

export const AccountsdRoute = new RouteBase({
  key: "accounts",
  priority: 1,
});

export const ProfileRoute = new RouteBase({
  key: "profile",
  icon: "/profile",
  priority: 1,
});

export const OperationsRoute = new RouteBase({
  key: "operations",
  path: "operations",
  priority: 1,
});

export const NearestBranchRoute = new RouteBase({
  key: "nearestBranch",
  path: "nearest-branch",
  priority: 1,
  parent: OperationsRoute,
});

export const MoneyTransferRoute = new RouteBase({
  key: "moneyTransfer",
  path: "money-transfer",
  priority: 1,
});

export const MoneyTransferAbroadRoute = new RouteBase({
  key: "transferAbroad",
  path: "abroad",
  priority: 1,
  parent: MoneyTransferRoute,
  clickable: false,
});

export const TransferToNameRoute = new RouteBase({
  key: "transferToName",
  path: "transfer-to-name",
  priority: 1,
  parent: MoneyTransferAbroadRoute,
});

export const TransferToAccountRoute = new RouteBase({
  key: "transferToAccount",
  path: "transfer-to-account",
  priority: 1,
  parent: MoneyTransferAbroadRoute,
});

export const TransferToCardRoute = new RouteBase({
  key: "transferToCard",
  path: "transfer-to-card",
  priority: 1,
  parent: MoneyTransferAbroadRoute,
});

export const TransferToWalletRoute = new RouteBase({
  key: "transferToWallet",
  path: "transfer-to-wallet",
  priority: 1,
  parent: MoneyTransferAbroadRoute,
});

export const MoneyTransferDomesticRoute = new RouteBase({
  key: "transferDomestic",
  path: "domestic",
  priority: 1,
  parent: MoneyTransferRoute,
  clickable: false,
});

export const TransferToNameDomesticRoute = new RouteBase({
  key: "transferToNameDomestic",
  path: "transfer-to-name",
  priority: 1,
  parent: MoneyTransferDomesticRoute,
});

export const TransferToAccountDomesticRoute = new RouteBase({
  key: "transferToAccountDomestic",
  path: "transfer-to-account",
  priority: 1,
  parent: MoneyTransferDomesticRoute,
});

export const TransferToCardDomesticRoute = new RouteBase({
  key: "transferToCardDomestic",
  path: "transfer-to-card",
  priority: 1,
  parent: MoneyTransferDomesticRoute,
});

export const TransferToCurrencyDomesticRoute = new RouteBase({
  key: "transferToCurrencyDomestic",
  path: "transfer-to-currency",
  priority: 1,
  parent: MoneyTransferDomesticRoute,
});

export const SavedTransactionsRoute = new RouteBase({
  key: "savedTransactions",
  path: "saved-transactions",
  priority: 1,
});

export const ConfirmationCancellationRoute = new RouteBase({
  key: "confirmCancelProcess",
  path: "confirm-cancel-process",
  priority: 1,
});

export const WhereMoneyRoute = new RouteBase({
  key: "whereMoneyPage",
  path: "where-money",
  priority: 1,
});

export const IbanVerificationRoute = new RouteBase({
  key: "ibanVerificationPage",
  path: "iban-verification",
  priority: 1,
});
